export default {
  404: "404",
  register: "Đăng ký",
  login: "Đăng nhập",
  profit: "Lợi nhuận",
  payout: "Mục tiêu thanh toán",
  btnDouble: "2×",
  wagered: "Đã cược",
  deposit: "Nạp tiền",
  inputFieldBtnMax: "Tối đa",
  bets: "Cược",
  topHeaderAmount: "Số tiền",
  resetPasswordTitle: "Đặt lại mật khẩu",
  resetPasswordNewPasswordTitle: "Mật khẩu mới",
  resetPasswordNewPasswordErrorsRequired: "Mật khẩu là bắt buộc.",
  resetPasswordNewPasswordErrorsMinLength: "Tối thiểu 8 ký tự.",
  resetPasswordNewPasswordErrorsMaxLength: "Tối đa 16 ký tự.",
  resetPasswordNewPasswordErrorsPattern:
    "Phải từ 8-16 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt (ví dụ: NextGen@123)",
  resetPasswordConfirmPasswordTitle: "Xác nhận mật khẩu",
  resetPasswordConfirmPasswordErrorsNotMatched: "Mật khẩu không khớp.",
  resetPasswordResetBtn: "Đặt lại",
  passwordResetSuccess: "Đổi mật khẩu thành công",
  resetPasswordWentWrong: "Đã xảy ra lỗi!",
  partners: "Đối tác",
  submit: "Gửi",
  signinUsername: "Email / Tên đăng nhập",
  signinForgetPassword: "Quên mật khẩu?",
  signinErrorsUserNameRequired: "Vui lòng nhập tên đăng nhập/email.",
  signinErrorsPasswordRequired: "Mật khẩu là bắt buộc.",
  signinErrorsPasswordMinLength: "Tối thiểu 8 ký tự.",
  signinErrorsPasswordMaxLength: "Tối đa 16 ký tự.",
  signinTryAgain: "Có lỗi xảy ra! Vui lòng thử lại.",
  signinResetPasswordUsernameErr:
    "Vui lòng nhập tên đăng nhập/email để đặt lại mật khẩu.",
  signinResetMailSentSuccessContent:
    "Chúng tôi đã gửi liên kết đặt lại mật khẩu vào email của bạn. Vui lòng kiểm tra email và đặt lại mật khẩu.",
  signupTitle: "Đăng ký",
  signupUsername: "Tên đăng nhập",
  signupEmail: "Email",
  signupWalletConnect: "Đăng nhập bằng Ví",
  signupPassword: "Mật khẩu",
  signupErrorsUserNameRequired: "Vui lòng nhập tên đăng nhập.",
  signupErrorsFirstNameRequired: "Vui lòng nhập tên.",
  signupErrorsLastNameRequired: "Vui lòng nhập họ.",
  signupErrorsUserNameMinLength: "Tối thiểu {{minimumCharacters}} ký tự.",
  signupErrorsUserNameMaxLength: "Tối đa {{maximumCharacters}} ký tự.",
  signupErrorsUserNamePattern: "Vui lòng chỉ nhập chữ và số.",
  signupErrorsStringPattern: "Vui lòng chỉ nhập chữ.",
  signupErrorsEmailRequired: "Vui lòng nhập email.",
  signupErrorsEmailPattern: "Vui lòng nhập email hợp lệ.",
  signupErrorsPasswordRequired: "Mật khẩu là bắt buộc.",
  signupErrorsPasswordMinLength: "Tối thiểu 8 ký tự.",
  signupErrorsPasswordMaxLength: "Tối đa 16 ký tự.",
  signupErrorsPasswordPattern:
    "Phải từ 8-16 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt (ví dụ: NextGen@123)",
  otpIsRequired: "OTP là bắt buộc",
  otpMustBeSixDigits: "OTP phải gồm 6 chữ số",
  enterOtp: "Nhập OTP",
  accountMenuTransactions: "Giao dịch",
  accountMenuPromotions: "Khuyến mãi",
  accountMenuProfile: "Hồ sơ",
  accountMenuLogout: "Đăng xuất",
  accountMenuWithdraw: "Rút tiền",
  pageNotFound: "Chúng tôi không thể tìm thấy trang bạn đang tìm kiếm!",
  error: "Lỗi",
  somethingWentWrong: "Đã xảy ra lỗi!",
  verifyEmailThankYou: "Cảm ơn!",
  verifyEmailEmailIsVerified: "Email của bạn đã được xác minh.",
  verifyEmailWentWrong: "Đã xảy ra lỗi!",
  verifyEmailTokenExpired: "Email đã được xác minh hoặc liên kết đã hết hạn",
  create: "Tạo",
  profilePassword: "Mật khẩu",
  profileUploadProfile: "Tải ảnh lên",
  profileErrorsEmailRequired: "Email là bắt buộc.",
  profileErrorsEmailPattern: "Vui lòng nhập email hợp lệ.",
  profileErrorsEmailMinLength: "Tối thiểu 3 ký tự.",
  profileErrorsEmailMaxLength: "Tối đa 20 ký tự.",
  profileMessagesProfileUpdate: "Cập nhật hồ sơ thành công",
  profileMessagesChangePassword: "Đổi mật khẩu thành công",
  profileProfilePicProfilePicUpload: "Tải ảnh đại diện lên",
  profileNoNewChanges: "Không thể cập nhật hồ sơ! Không có thay đổi mới.",
  profileLoggedInWithSocial: "Bạn đã đăng nhập bằng hình thức mạng xã hội.",
  profileSideNavigatorSound: "Âm thanh",
  profileSideNavigatorMusic: "Nhạc",
  profileSideNavigatorProfile: "Hồ sơ của tôi",
  profileSideNavigatorBetHistory: "Lịch sử cược",
  profileSideNavigatorTransactions: "Giao dịch",
  profileSideNavigatorDeposit: "Nạp tiền",
  withdraw: "Rút tiền",
  profileSideNavigatorGameLimits: "Giới hạn trò chơi",
  profileSideNavigatorReferral: "Giới thiệu",
  profileSideNavigatorChangePassword: "Đổi mật khẩu",
  profileSideNavigatorTermsConditions: "Điều khoản & Điều kiện",
  profileSideNavigatorLogOut: "Đăng xuất",
  profileSideNavigatorProvablyFair: "Công nghệ công bằng",
  WalletInfoSectionNotAvailable: "Không khả dụng",
  WalletInfoSectionRealBalance: "Số dư thực",
  GameLimitsMinimumBet: "Cược tối thiểu",
  GameLimitsMaximumBet: "Cược tối đa",
  GameLimitsMaxWinFor1Bet: "Thắng tối đa cho một lượt cược",
  ProvablyFairSubTitle:
    "Trò chơi này sử dụng công nghệ Provably Fair để xác định kết quả. Công cụ này cho phép bạn thay đổi seed và kiểm tra tính công bằng.",
  ProvablyFairMaximumBet: "Cược tối đa:",
  ProvablyFairMaxWinFor1Bet: "Thắng tối đa cho một lượt cược",
  promotionsTitle: "Khuyến mãi",
  promotionsNoLosingData: "Rất tiếc, không có khuyến mãi hoàn thua cho ",
  promotionsNoDepositData: "Rất tiếc, không có khuyến mãi nạp tiền cho ",
  promotionsCurrency: " tiền tệ.",
  promotionsViewBtn: "Xem",
  promotionsClaimSuccess: "Bạn đã nhận thành công",
  promotionsAvailability: "Hiệu lực: ",
  promotionsAvailabilityTabLosing: "Hoàn thua",
  promotionsAvailabilityTabDeposit: "Thưởng nạp",
  promotionsDepositBonusTableCode: "Mã",
  promotionsDepositBonusTableMinDeposit: "Nạp tối thiểu",
  promotionsDepositBonusTablePercentage: "Phần trăm",
  promotionsDepositBonusTableMaxBonus: "Thưởng tối đa",
  promotionsDepositBonusTableRolloverMultipler: "Vòng cược yêu cầu",
  promotionsDepositBonusTableMaxRolloverPerBet: "Tối đa vòng cược mỗi lượt",
  promotionsDepositBonusTableTimeToAchieveRolloverTarget:
    "Thời gian để hoàn thành vòng cược",
  promotionsBonusCode: "MÃ THƯỞNG: ",
  promotionsLossesClaim:
    "Có thể yêu cầu hoàn thua (trong thời gian chiến dịch): ",
  promotionsLossesClaimLosingBonusTablePercentage: "Phần trăm",
  promotionsLossesClaimLosingBonusTableMinLosingAmount:
    "Số tiền thua tối thiểu",
  promotionsBonusStatus: "Trạng thái Bonus: ",
  promotionsBonusAmount: "Số tiền Bonus: ",
  promotionsRolloverTarget: "Mục tiêu vòng cược: ",
  promotionsRolloverAchieved: "Vòng cược đã đạt được: ",
  promotionsActivatebtn: "KÍCH HOẠT",
  promotionsClaimBtn: "NHẬN",
  promotionsCancelBtn: "HỦY",
  promotionsBackBtn: "QUAY LẠI",
  promotionsBonus: "Bonus",
  promotionsTermAndConditions: " Điều khoản & Điều kiện",
  promotionsClaimDepositBonusTitle: "Các bước để nhận thưởng nạp tiền",
  promotionsClaimDepositBonusFirst: "Kích hoạt mã Bonus",
  promotionsClaimDepositBonusSecond: "Nạp tiền vào ví",
  promotionsClaimDepositBonusThird:
    "Hoàn thành mục tiêu vòng cược để nhận thưởng",
  promotionsClaimLosingBonusTitle: "Các bước để nhận thưởng hoàn thua",
  promotionsClaimLosingBonusFirst: "Kích hoạt mã Bonus",
  promotionsClaimLosingBonusSecond: "Chơi các trò chơi yêu thích",
  promotionsClaimLosingBonusThird:
    "Nhấn 'Nhận hoàn thua' để yêu cầu hoàn thua trong thời gian chiến dịch",
  promotionsWentWrong: "Đã xảy ra lỗi!",
  transactionTitle: "Giao dịch",
  transactionBetId: "Mã cược",
  transactionUser: "Người chơi",
  transactionPayout: "Thanh toán",
  transactionAmount: "Số tiền",
  transactionTime: "Ngày",
  transactionProfit: "Lợi nhuận",
  transactionCashout: "Rút tiền",
  transactionBet: "Cược",
  transactionMultix: "Multi.x",
  transactionWin: "Thắng",
  transactionFairness: "Công bằng",
  transactionReferFriend: "Giới thiệu bạn bè",
  transactionTotal: "Tổng số cược",
  transactionWins: "Thắng",
  transactionRefresh: "Làm mới",
  transactionFilterTopMultipliers: "Nhân thưởng cao nhất",
  transactionFilterHugeWins: "Thắng lớn",
  transactionFilterBiggestWins: "Thắng lớn nhất",
  transactionFilterMultipliers: "Hệ số",
  transactionRealBalance: "Số dư thực",
  depositWithdrawTXDate: "Ngày",
  depositWithdrawTXAmount: "Số tiền",
  depositWithdrawTXTxId: "TxID",
  depositWithdrawTXTxType: "Loại giao dịch",
  depositWithdrawTXStatus: "Trạng thái",
  depositWithdrawTXNoData: "Không có dữ liệu.",
  depositTitle: "Nạp tiền",
  depositHistory: "Lịch sử",
  depositSubTitle:
    "Người dùng không thể nạp hoặc rút tiền fiat. Vui lòng liên hệ Admin để giao dịch bằng tiền fiat.",
  depositCopyNotSupported:
    "Trình duyệt của bạn không hỗ trợ tự động sao chép vào bộ nhớ tạm.\nVui lòng sao chép mã thủ công.",
  depositCopied: "Đã sao chép địa chỉ.",
  withdrawNoBalance: "Số dư không đủ.",
  withdrawMinAmount: "Vui lòng nhập số tiền lớn hơn hoặc bằng {{min}}.",
  paginationNextBtn: "Tiếp",
  paginationPrevBtn: "Trước",
  LoginRequired: "Yêu cầu đăng nhập!",
  betPlacedSuccessfully: "Đặt cược thành công",
  betCancelledSuccessfully: "Đã hủy cược thành công",
  PlayerEscapedSuccessfully: "Người chơi đã thoát",
  CopiedSuccessfull: "Sao chép thành công",
  usersConsent:
    "Khi truy cập trang web này, tôi xác nhận rằng tôi đủ 18 tuổi, và đã xem,\n hiểu và đồng ý với",
  termsOfService: "Điều khoản dịch vụ",
  email: "Email",
  playNow: "Chơi ngay",
  orContinueWith: "Hoặc tiếp tục với",
  metamaskExtensionNotAvailable:
    "Vui lòng cài đặt tiện ích MetaMask và tải lại trang.",
  cashier: "NẠP TIỀN",
  account: "TÀI KHOẢN",
  hello: "Xin chào",
  balance: "Số dư",
  referrals: "Giới thiệu",
  settings: "Cài đặt",
  withdrawals: "Rút tiền",
  demoWallet: "Ví Demo",
  wallet: "Ví",
  user: "Người dùng",
  amountIsRequired: "Số tiền là bắt buộc",
  minDepositAmount: "Số tiền nạp phải lớn hơn {{min}}.",
  maxDepositAmount: "Số tiền nạp phải nhỏ hơn {{max}}.",
  minWithdrawAmount: "Phải lớn hơn {{min}}",
  withdrawMustLessThanWallet: "Số tiền rút phải nhỏ hơn số dư ví của bạn",
  accountTypeIsRequired: "Loại tài khoản là bắt buộc.",
  mobileNumberLength: "Số điện thoại phải có {{length}} chữ số",
  phoneIsRequired: "Số điện thoại là bắt buộc",
  cpfError: "CPF phải dài {{length}} ký tự",
  cpfRequiredError: "CPF là bắt buộc",
  cnpjError: "CNPJ phải dài {{length}} ký tự",
  mainMenu: "MENU CHÍNH",
  casino: "Casino",
  sports: "Thể thao",
  crypto: "Crypto",
  NextGenXp: "NextGen xp",
  playEarn: "chơi & nhận thưởng",
  NFT: "NFT",
  poker: "Poker",
  earnRewards: "NHẬN THƯỞNG",
  rankUp: "Thăng hạng",
  inviteFriends: "Mời bạn bè",
  affiliates: "Đối tác",
  sportsbook: "Cá cược thể thao",
  menu: "Menu",
  allBets: "Tất cả cược",
  highRollers: "Cược thủ lớn",
  luckyBets: "Cược may mắn",
  trade: "Giao dịch",
  player: "NGƯỜI CHƠI",
  time: "THỜI GIAN",
  wager: "TIỀN CƯỢC",
  payoutText: "THANH TOÁN",
  bannerHeadOne: "Trải nghiệm sự đổi mới thực sự với",
  bannerHeadTwo: "chương trình thưởng cao nhất trong ngành.",
  registerNow: "Đăng ký ngay",
  copy: "Sao chép",
  liveWins: "THẮNG TRỰC TIẾP",
  monthlyStatus: "T",
  weeklyStatus: "T",
  dailyStatus: "N",
  nextEcosystem: "hệ sinh thái nextgen",
  allGames: "Tất cả trò chơi",
  allSports: "Tất cả môn thể thao",
  cryptoFutures: "giao dịch tương lai crypto",
  tradeNow: "Giao dịch ngay",
  allTables: "Tất cả bàn chơi",
  nft: "NFT",
  viewAll: "Xem tất cả",
  rewards: "Phần thưởng",
  profile: "Hồ sơ",
  nextgenProfile: "HỒ SƠ NEXTGEN",
  totalBets: "Tổng số cược",
  totalWagered: "Tổng số tiền cược",
  joinDate: "Ngày tham gia",
  displaySocialLinks: "Hiển thị tài khoản mạng xã hội liên kết",
  privateProfile: "Hồ sơ riêng tư",
  rank: "Hạng",
  nextRank: "Hạng tiếp theo",
  changeUsername: "Đổi tên người dùng",
  newPassword: "Mật khẩu mới",
  repeatNewPassword: "Nhập lại mật khẩu mới",
  changeName: "Đổi tên",
  linkSocialAccount: "Liên kết mạng xã hội",
  privateProfileTooltip:
    "Khi hồ sơ của bạn để riêng tư, người dùng khác sẽ không thể thấy hoạt động cược, phần thưởng hoặc liên kết mạng xã hội của bạn.",
  socialLinksTooltip:
    "Liên kết tài khoản mạng xã hội để người khác có thể theo dõi bạn.",
  balances: "số dư",
  createReferralBalance: "Tạo số dư giới thiệu",
  total: "Tổng",
  tips: "Tips",
  receivedAmount: "Số tiền nhận",
  dateOrTime: "Ngày/Giờ",
  view: "Xem",
  allChains: "Tất cả chuỗi",
  creditAmount: "Số tiền tín dụng",
  setCustomReferralLink: "Tạo liên kết giới thiệu tùy chỉnh",
  changeEmail: "Đổi email",
  newEmail: "Email mới",
  newUsername: "Tên người dùng mới",
  username: "Tên người dùng",
  changePassword: "Đổi mật khẩu",
  twoFactorAuthentication: "xác thực hai yếu tố",
  twoFactorAuthenticationTitle:
    "Khuyến nghị sử dụng Xác thực Hai Yếu Tố vì nó bảo vệ tài khoản bằng cả mật khẩu và điện thoại của bạn. Email và mật khẩu phải được đặt trước khi kích hoạt 2FA. Khi 2FA được bật, bạn sẽ không thể đăng nhập bằng Steam.",
  enable2fa: "Bật 2FA",
  verifyIdentityByKyc: "Xác minh danh tính (KYC)",
  oldPassword: "Mật khẩu cũ",
  live: "Trực tiếp",
  soccer: "Bóng đá",
  tennis: "Quần vợt",
  fifa: "Fifa",
  basketball: "Bóng rổ",
  iceHockey: "Khúc côn cầu trên băng",
  volleyball: "Bóng chuyền",
  tableTennis: "Bóng bàn",
  baseball: "Bóng chày",
  golf: "Golf",
  boxing: "Quyền anh",
  myBets: "Cược của tôi",
  favourites: "Yêu thích",
  americanFootball: "Bóng bầu dục Mỹ",
  buyCrypto: "Mua Crypto",
  oldEmail: "Email cũ",
  loggedInSuccess: "Đăng nhập thành công",
  loggedOutSuccess: "Đăng xuất thành công",
  signup: "Đăng ký hoàn tất",
  tokenVerify: "Mã xác minh đã được gửi đến email của bạn. Vui lòng xác minh.",
  emailVerify: "Email đã được xác minh",
  emailChangedSuccess: "Email đã cập nhật",
  emailUpdateOtp: "OTP đã được gửi đến email mới",
  profileUpdatedSuccess: "Hồ sơ đã cập nhật",
  otpVerified: "Mã OTP đã xác minh",
  twoFADeactivated: "Xác thực hai yếu tố đã tắt",
  internalServerError: "Lỗi máy chủ nội bộ",
  unAuthorized: "Không được phép",
  dataNotFound: "Không tìm thấy dữ liệu",
  setReferralLink: "Tạo liên kết giới thiệu...",
  notFound: "Không tìm thấy",
  nextgenOriginals: "Top trò chơi",
  status: "Trạng thái",
  success: "Thành công",
  failed: "Thất bại",
  pending: "Đang xử lý",
  date: "Ngày",
  to: "Đến",
  roundId: "Mã vòng",
  bet: "Cược",
  win: "Thắng",
  at: "tại",
  downloadAll: "Tải xuống tất cả",
  gameText: "Trò chơi",
  searchGames: "Tìm trò chơi",
  provider: "Nhà cung cấp",
  search: "Tìm kiếm",
  all: "Tất cả",
  sortBy: "Sắp xếp theo",
  popular: "Phổ biến",
  loadMore: "Tải thêm",
  bitcoin: "Bitcoin",
  btc: "BTC",
  chat: "Chat",
  loginToChat: "Đăng nhập để chat",
  send: "Gửi",
  expand: "Mở rộng",
  collapse: "Thu gọn",
  emailPlaceholder: "youremail@domain.com",
  removeFromFavourite: "Xóa khỏi yêu thích",
  addToFavourite: "Thêm vào yêu thích",
  verify: "Xác minh",
  accountVerification: "Xác minh tài khoản",
  recentlyPlayed: "Đã chơi gần đây",
  moreFrom: "Thêm từ",
  demoMode: "Chế độ Demo",
  providersList: "Danh sách nhà cung cấp",
  games: "Trò chơi",
  providers: "Nhà cung cấp",
  close: "Đóng",
  joinedOn: "Tham gia vào",
  rewarded: "Được thưởng",
  saySomething: "Viết gì đó",
  addressIsRequired: "Địa chỉ là bắt buộc",
  withdrawRequestSent: "Yêu cầu rút tiền đã gửi. Đang chờ phê duyệt.",
  noMatchesFound: "Không tìm thấy kết quả",
  tip: "TIP",
  sendTip: "Gửi tip",
  minAmount: "Số tiền phải lớn hơn {{min}}",
  maxAmount: "Số tiền phải nhỏ hơn {{max}}",
  doNotShowTip: "Không hiển thị tip trong chat",
  demoAvailable: "Có demo",
  denoNotAvailable: "Không có demo",
  goFullscreen: "Toàn màn hình",
  endsAt: "Kết thúc lúc",
  inProgress: "Đang diễn ra",
  eventEnd: "Kết thúc sự kiện",
  latestPromotions: "Khuyến mãi mới nhất",
  archived: "Đã lưu trữ",
  noPromotionsFound: "Không tìm thấy khuyến mãi",
  claim: "Nhận",
  add: "Thêm",
  viewDashboard: "Xem Dashboard",
  prize: "Giải thưởng",
  timeLeft: "Thời gian còn lại",
  viewTransactions: "Xem giao dịch",
  sendAmountInCashier:
    "Gửi số tiền {{- currency}} bạn muốn đến địa chỉ sau để nhận số Coins tương ứng.",
  yourPersonalDepositAddress: "Địa chỉ nạp {{- currency}} cá nhân của bạn",
  copyAddress: "Sao chép địa chỉ",
  theValueOfCurrencyMayChange:
    "Giá trị của {{- currency}} có thể thay đổi giữa thời điểm bạn gửi và thời điểm chúng tôi nhận được.",
  doNotHaveAnyCurrency: "Không có {{- currency}}?",
  depositOptions: "Tùy chọn nạp tiền",
  withdrawalOptions: "Tùy chọn rút tiền",
  withdrawCurrency: "Rút {{- currency}}",
  enterAddressToReceiveFunds:
    "Vui lòng nhập địa chỉ ví {{- currency}} bạn muốn nhận tiền. Sau khi xác nhận, yêu cầu rút thường được xử lý trong vài phút.",
  receivingCurrencyAddress: "Địa chỉ nhận {{- currency}}",
  withdrawalAmount: "Số tiền rút",
  pasteYourCurrencyAddressHere:
    "Dán địa chỉ ví {{- currency}} của bạn vào đây...",
  request: "Yêu cầu",
  receiveTheSpecifiedAmount:
    "*Bạn sẽ nhận số {{- currency}} được chỉ định vào địa chỉ rút tiền của mình",
  valueMayVary:
    "*Giá trị trừ vào số dư của bạn có thể thay đổi giữa thời điểm bạn yêu cầu và khi chúng tôi xử lý",
  coupons: "Coupon",
  updateEmail: "Cập nhật email",
  update: "Cập nhật",
  loginHistory: "Lịch sử đăng nhập",
  showLoginHistory: "Hiển thị lịch sử đăng nhập",
  wagerErr: "Số tiền cược là bắt buộc",
  minWagerErr: "Số tiền cược tối thiểu là 1",
  mulValErr: "Giá trị hệ số từ 1 - 1000",
  closeBetErr: "Nhập số tiền đóng cược hợp lệ",
  profitErr: "Nhập số tiền chốt lời hợp lệ",
  multiplierErr: "Yêu cầu nhập hệ số nhân",
  manual: "Thủ công",
  auto: "Tự động",
  pnLFee: "Phí PnL",
  flatFee: "Phí cố định",
  takeProfitLabel: "CHỐT LỜI TẠI GIÁ",
  closeBetLabel: "ĐÓNG CƯỢC TẠI GIÁ",
  priceUpLabel: "GIÁ SẼ TĂNG HAY GIẢM?",
  up: "Tăng",
  down: "Giảm",
  payoutMul: "HỆ SỐ THANH TOÁN",
  safe: "An toàn",
  wild: "Mạo hiểm",
  placeBet: "Đặt cược",
  roundEnd: "VÒNG KẾT THÚC TRONG",
  timerInfo:
    "Tất cả cược Rollercoaster sẽ được đóng và giá sẽ reset về $1.000 mỗi ngày lúc 00:00 UTC",
  month: "tháng",
  PNL: "Lãi/Lỗ",
  ROI: "ROI",
  roi: "roi",
  funding: "Funding/Giờ",
  exitPriceLabel: "Giá thoát",
  cashedOut: "Đã thoát",
  open: "Đang mở",
  chartPreferences: "Tùy chỉnh biểu đồ",
  yAxis: "Tùy chỉnh trục Y",
  additionalFeatures: "Tính năng bổ sung",
  themes: "Giao diện",
  locale: "Ngôn ngữ",
  changeTimezone: "Thay đổi múi giờ",
  changeLanguage: "Thay đổi ngôn ngữ",
  tooltip: "Tooltip",
  field: "Trường",
  value: "Giá trị",
  dateTime: "Ngày/Giờ",
  winningAmount: "Số tiền thắng",
  activeBets: "Cược đang hoạt động",
  closedBets: "Cược đã đóng",
  publicBets: "Cược công khai",
  leaderboard: "Bảng xếp hạng",
  howToPlay: "Cách chơi",
  rOICalculator: "Máy tính ROI",
  allInstruments: "Tất cả công cụ",
  week: "Tuần",
  monthLabel: "Tháng",
  day: "Ngày",
  betLabel: "CƯỢC",
  entryPrice: "GIÁ VÀO",
  bustPriceLabel: "Giá phá sản",
  multiplierLabel: "HỆ SỐ",
  exitPrice: "GIÁ THOÁT",
  pnl: "Lãi/Lỗ",
  details: "Xem chi tiết",
  profitLoss: "Lợi nhuận & Thua lỗ",
  noBalance: "Số dư không đủ.",
  maxBetAmount: "Số tiền cược tối đa",
  limit: "vượt giới hạn.",
  minBetAmount: "Số tiền cược tối thiểu",
  rollsLimitMsg: "Số lượt quay phải nhỏ hơn hoặc bằng 100.",
  mines: "Mines",
  loginFailed: "Đăng nhập thất bại",
  noEntries: "Không có mục nào",
  descriptionIsRequired: "Yêu cầu mô tả",
  description: "Mô tả",
  report: "Báo cáo",
  userReportedSuccessfully: "Đã báo cáo người dùng",
  tipSendSuccessfully: "Đã gửi tip",
  walletSettings: "Cài đặt ví",
  hideZero: "Ẩn số dư bằng 0",
  hideZeroInfo: "Số dư bằng 0 sẽ không hiển thị trong ví của bạn",
  displayFiat: "Hiển thị crypto dưới dạng fiat",
  displayFiatInfo:
    "Tất cả cược và giao dịch sẽ được quy đổi tương đương sang fiat",
  noteForApprox: "Lưu ý rằng đây chỉ là giá trị ước tính.",
  save: "Lưu",
  limits: "Giới hạn",
  wagerLimit: "Giới hạn cược",
  lossLimit: "Giới hạn thua",
  depositLimit: "Giới hạn nạp",
  takeABreak: "Tạm nghỉ",
  customTimePeriod: "Thời gian tùy chỉnh",
  timePeriod: "Khoảng thời gian",
  selfExclusion: "Tự loại trừ",
  confirm: "Xác nhận",
  setLimit: "Đặt giới hạn",
  removeLimit: "Xóa giới hạn",
  enterAmount: "Nhập số tiền",
  hours: "Giờ",
  daily: "Hàng ngày",
  weekly: "Hàng tuần",
  monthly: "Hàng tháng",
  cancel: "Hủy",
  usedLimit: "Giới hạn đã dùng",
  type: "Loại",
  updatedAt: "Cập nhật lúc",
  editLimit: "Chỉnh sửa giới hạn",
  limitRemovedMessage: "Giới hạn sau sẽ được xóa.",
  setLimitMessage:
    "Bạn sắp đặt giới hạn này cho tài khoản. Lưu ý, nếu muốn thay đổi giới hạn, bạn có thể làm vậy sau 24 giờ.",
  setBreakMessage:
    "Bạn sắp khóa tài khoản trong thời gian đặt trước. Trong thời gian này, bạn sẽ không thể đăng nhập để thay đổi thời gian khóa. Nếu muốn thay đổi hoặc gia hạn, hãy liên hệ hỗ trợ trực tiếp.",
  setSessionLimitMessage:
    "Bạn sắp đặt giới hạn phiên cho tài khoản. Nếu muốn thay đổi giới hạn, sẽ mất 24 giờ để áp dụng giới hạn mới.",
  removeSessionLimitMessage: "Giới hạn phiên sẽ được xóa",
  notAchieved: "chưa đạt",
  flexibleRegistration: "Đăng ký linh hoạt!",
  mostPlayed: "Chơi nhiều nhất",
  badge: "Huy hiệu",
  allBadges: "Tất cả huy hiệu",
  socialMedia: "Mạng xã hội",
  allLinks: "Tất cả liên kết",
  statistics: "Thống kê",
  newMessage: "Tin nhắn mới",
  tipFor: "tip cho",
  play: "Chơi",
  betOn: "Đặt cược vào",
  liveCasino: "Casino trực tuyến",
  ecosystemUnbeatableOdds:
    "Cược tốt hơn - Nhận tỷ lệ cược hấp dẫn trên những sự kiện thú vị!",
  startBetting: "Bắt đầu cược",
  ecosystemJoinTheFun:
    "Tham gia vui chơi - Khám phá game độc quyền của NextGen và hơn +9,000 trò chơi casino!",
  futures: "Hợp đồng tương lai",
  ecosystemTrade:
    "NGB là cổng vào thế giới game & nền tảng cược trực tuyến thế hệ mới!",
  ecosystemCasino24x7:
    "Trải nghiệm casino trực tiếp với dealer chuyên nghiệp mọi lúc, mọi nơi!",
  joinNow: "Tham gia ngay",
  noNotificationsFound: "Không có thông báo",
  notifications: "Thông báo",
  lobby: "Sảnh",
  rollercoaster: "NextGen Coaster",
  applyReferralCode: "Áp dụng mã giới thiệu",
  referralCode: "Mã giới thiệu",
  referralLink: "Liên kết giới thiệu",
  copyLink: "Sao chép liên kết",
  referralLinkCopied: "Đã sao chép liên kết",
  withdrawAddressCannotBeSame:
    "Địa chỉ rút tiền không thể trùng với địa chỉ của bạn",
  userId: "ID người dùng",
  active: "Hoạt động",
  inactive: "Không hoạt động",
  currency: "Tiền tệ",
  hostGames: "Tổ chức trò chơi,",
  earnCrypto: "Kiếm crypto",
  inviteHostAndEarn:
    "Mời, tổ chức & kiếm tiền - Tạo sự kiện NextGen của riêng bạn",
  startEarning: "Bắt đầu kiếm",
  nextGen: "NextGen",
  whitePaper: "Whitepaper",
  deepDiveInto: "Khám phá sâu về nền kinh tế NextGen Coin",
  learnMore: "Tìm hiểu thêm",
  sport: "thể thao",
  vipRanked: "Xếp hạng VIP",
  betMoreEarnMore: "Cược nhiều hơn, nhận nhiều hơn",
  expiresAt: "Hết hạn vào",
  upload: "Tải lên",
  pleaseSelectImage: "Vui lòng chọn hình ảnh",
  imageSizeMustLessThan: "Kích thước ảnh phải nhỏ hơn {{size}} mb",
  imageSizeFormat: "Chỉ hỗ trợ định dạng png, jpeg, jpg.",
  maxFileSize: "Tối đa 2 MB",
  dragPosition: "Kéo để thay đổi vị trí",
  onlyNumbers: "Chỉ nhập số",
  cannotBeRemoved: "Không thể xóa",
  amountInBetween: "Số tiền phải nằm giữa giới hạn ngày và tháng",
  amountEqualOrGreater: "Số tiền phải lớn hơn hoặc bằng giới hạn tuần",
  amountEqualOrLess: "Số tiền phải nhỏ hơn hoặc bằng giới hạn tuần và tháng",
  cannotBeIncreased: "Không thể tăng",
  enterPassword: "Nhập mật khẩu",
  sessionLimit: "Giới hạn phiên",
  timePeriodRequired: "Yêu cầu thời gian",
  amountGTZero: "Số tiền phải lớn hơn 0",
  mma: "MMA",
  counterStrike: "Counter Strike",
  rugbyUnion: "Rugby Union",
  valorant: "Valorant",
  cricket: "Cricket",
  dota: "DOTA-2",
  rugbyLeague: "Rugby League",
  hilo: "Hilo",
  crash: "Crash",
  cancelBetSuccessfully: "Đã hủy cược",
  start: "Bắt đầu",
  invalidBetAmount: "Số tiền cược không hợp lệ",
  zeroError: "Phải lớn hơn 0",
  flipCoin: "Tung đồng xu",
  customs: "Tùy chỉnh",
  redeemCode: "ĐỔI MÃ COUPON",
  couponText: "Chúng tôi thường đăng mã ở",
  copyrightText:
    "<aLink>{{website}}</aLink> is owned by {{companyName}}, a Limited Company registered in Cyprus. License Registration Number {{licenseNumber}}.",
  platform: "Nền tảng",
  support: "Hỗ trợ",
  faq: "FAQ",
  partnershipProgram: "Chương trình đối tác",
  blog: "Blog",
  helpCenter: "Trung tâm trợ giúp",
  aboutUs: "Về chúng tôi",
  community: "Cộng đồng",
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  discord: "Discord",
  english: "Tiếng Anh",
  hindi: "Tiếng Hindi",
  french: "Tiếng Pháp",
  legal: "Pháp lý",
  cryptoTransactions: "Giao dịch Crypto",
  sendersName: "Tên người gửi",
  hideLoginHistory: "Ẩn lịch sử đăng nhập",
  loginMethod: "Phương thức đăng nhập",
  deviceType: "Loại thiết bị",
  ip: "IP",
  tradingDefinition:
    "Giao dịch tiền mã hóa không phải là cờ bạc theo định nghĩa, vì vậy nó không thuộc phạm vi giấy phép trò chơi của chúng tôi.",
  perks: "Quyền lợi",
  connected: "Kết nối thành công",
  twitch: "Twitch",
  connect: "Kết nối",
  setUpGoogleAuthenticator: "CÀI ĐẶT GOOGLE AUTHENTICATOR",
  twoFACode: "MÃ 2FA",
  downloadTheGoogleAuthenticator:
    "1. Tải ứng dụng Google Authenticator cho iPhone hoặc Android",
  saveTheFollowingAccountToken:
    "2. Lưu Mã tài khoản (Key) dưới đây ở nơi an toàn",
  accountTokenKey: "Mã tài khoản (Key)",
  scanQRCodeWithApp: "3. Quét mã QR bằng ứng dụng Google Authenticator",
  enterTheTokenBelow: "4. Nhập mã bên dưới",
  copied: "Đã sao chép",
  code: "Mã",
  furtherVerificationRequired: "Yêu cầu xác minh bổ sung",
  firstName: "Tên",
  lastName: "Họ",
  dateOfBirth: "Ngày sinh",
  year: "Năm",
  addressLine: "Địa chỉ",
  addressLineTwo: "Địa chỉ dòng 2",
  city: "Thành phố",
  province: "Tỉnh/Bang",
  postalCode: "Mã bưu điện",
  country: "Quốc gia",
  submitInformation: "Gửi thông tin",
  level: "Cấp độ",
  required: "Bắt buộc",
  rejected: "Bị từ chối",
  completed: "Hoàn thành",
  cancelled: "Đã hủy",
  onHold: "Tạm giữ",
  kycRequestSubmittedSuccessfully: "Yêu cầu KYC đã được gửi",
  reRequested: "Yêu cầu lại",
  cashBalance: "Số dư tiền mặt",
  bonusBalance: "Số dư tiền thưởng",
  specialBonus: "Thưởng đặc biệt",
  today: "Hôm nay",
  noRewards: "Không có phần thưởng",
  viewPendingRewards: "Xem phần thưởng đang chờ",
  totalClaimed: "Tổng đã nhận",
  pendingRewards: "Phần thưởng đang chờ",
  amount: "Số tiền",
  others: "Khác",
  createdAt: "Tạo lúc",
  horseRacing: "Đua ngựa",
  addToHomeScreen: "Thêm NextGen vào màn hình chính",
  oneTabAccess: "Truy cập 1 chạm trên điện thoại",
  install: "Cài đặt",
  addToHome: "Thêm vào màn hình chính",
  inChromeSafari: "Trong Chrome/Safari, nhấn vào",
  buttonAndChoose: "nút và chọn",
  afterCompletingThisStep:
    "Sau khi hoàn tất, bạn có thể truy cập NextGen Bets chỉ với một chạm!",
  settlementId: "Mã thanh toán",
  commission: "Hoa hồng",
  totalCommission: "Tổng hoa hồng",
  commissionSettlement: "Thanh toán hoa hồng",
  startplaying: "Bắt đầu chơi",
  forgotPassword: "Quên mật khẩu",
  resetPassword: "Đặt lại mật khẩu",
  locked: "Đã khóa",
  unlocked: "Đã mở khóa",
  yourRank: "Xếp hạng của bạn",
  nextRanks: "Các hạng tiếp theo",
  allRanks: "Tất cả hạng",
  bonusClaimedSuccessfully: "Đã nhận thưởng",
  passwordUpdated: "Mật khẩu đã được cập nhật!",
  thatsOkayItHappens: "Không sao đâu. Nhấn vào nút bên dưới để tiếp tục. Email",
  passwordsMustMatch: "Mật khẩu phải trùng khớp",
  youNearlyThere: "Bạn sắp hoàn tất!",
  weSendYouVerificationEmail:
    "Chúng tôi đã gửi một email xác minh. Vui lòng kiểm tra email và xác minh tài khoản.",
  verifyEmailAddress: "Xác minh địa chỉ email",
  pleaseNoteThatTheLinkWillExpire:
    "Lưu ý: liên kết sẽ hết hạn trong 5 ngày. Nếu bạn không đăng ký NextGen Bets, hãy bỏ qua email này.",
  autoBetStops: "Tự động dừng cược do vượt giới hạn tiền cược",
  casinoBets: "Cược Casino",
  sportsBet: "Cược thể thao",
  cryptoTrades: "Giao dịch Crypto",
  customBets: "Cược tùy chỉnh",
  nothingFound: "Không tìm thấy",
  bonus: "Thưởng",
  claimedAt: "Đã nhận lúc",
  available: "Có sẵn",
  previous: "Trước",
  next: "Tiếp",
  tooManyRequests: "Quá nhiều yêu cầu.",
  limitUpdatedSuccessFully: "Giới hạn đã được cập nhật",
  youLost: "Bạn đã thua",
  cashOutFailed: "Rút tiền thất bại",
  betAlreadyPlaced: "Đã đặt cược",
  betCashedOut: "Cược đã rút",
  noFavouritesIn: "Không có mục yêu thích trong",
  team: "Đội ngũ NextGen",
  fiatAmount: "Số tiền Fiat",
  cryptoAmount: "Số tiền Crypto",
  moonpay: "Moonpay",
  paymentMethod: "Phương thức thanh toán",
  transactionId: "Mã giao dịch",
  address: "Địa chỉ",
  comingSoon: "Sắp ra mắt!",
  minOneCharacterRequired: "Yêu cầu ít nhất một ký tự",
  verifyOtp: "Xác minh OTP",
  noResults: "Không có kết quả",
  moreFromBrand: "Nhiều hơn từ NextGen Bets",
  cryptoDeposit: "Nạp Crypto",
  cryptoWithdraw: "Rút Crypto",
  fiatDeposit: "Nạp Fiat",
  fiatWithdraw: "Rút Fiat",
  goToPaymentsPage: "Đi tới trang thanh toán.",
  bankTransfer: "Chuyển khoản ngân hàng",
  initiateTransfer: "Bắt đầu chuyển khoản",
  emt: "EMT",
  initiateEmt: "Bắt đầu EMT",
  checkYourMailForFurtherDetails: "Kiểm tra email để biết thêm chi tiết",
  gigadet: "Gigadet",
  wallet88: "Wallet88",
  select_language: "Chọn ngôn ngữ",
  raise_a_ticket: "Tạo phiếu hỗ trợ",
};
